import React from 'react'
import { PersonsSectionProps } from './PersonsSection.types'
import styles from './PersonsSection.module.scss'
// import cl from 'classnames'
import { GallerySection } from '../GallerySection'
import { Button, ImagePortrait, Text1 } from 'components/shared'
import { getMainImageSrcForObj, noImageAvatar } from 'utilities'
import { capitalize } from '@material-ui/core'
import { IconDelete } from 'assets'

const PersonsSectionComponent = (props: PersonsSectionProps) => {
  const {
    list = [], 
    personType,
    onAddButtonClick,
    onRemovePerson
  } = props;

  const WIDTH = 94;

  return (
    <GallerySection
      title={capitalize(personType)}
      count={list.length}
      addButtonProps={{
        width: WIDTH,
        label: 'Add person',
        onClick: onAddButtonClick
      }}
    >
      {list.map((person, index) => (
        <div
          key={index}
          style={{ maxWidth: WIDTH }}
          className={styles.container}
        >
          <ImagePortrait
            src={getMainImageSrcForObj(person) || noImageAvatar}
            width={WIDTH}
          />
          <Text1 overflowEllipsis title={person.name}>
            {person.name}
          </Text1>

          <Button
            preset='icon'
            className={styles.removeButton}
            title='Remove person'
            onClick={() => onRemovePerson && onRemovePerson(person.id)}
          >
            <IconDelete />
          </Button>
        </div>
      ))}
    </GallerySection>
  )
}

const PersonsSection = PersonsSectionComponent
export { PersonsSection }
